import React from 'react';

import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'


export class Waiting extends React.Component {
    constructor() {
        super();

        this.cancel = this.cancel.bind(this);
        this.start = this.start.bind(this);
    }

    componentDidMount() {
        this.disabledGo = false;
    }

    cancel() {
        this.props.socket.send(JSON.stringify({ kind: "cancel" }));
        this.props.onCancel();
    }

    start() {
        this.props.socket.send(JSON.stringify({ kind: "startGame" }));
        this.disabledGo = true;
        this.forceUpdate();
    }

    render() {
        let content;

        if (this.props.waitingFor.length == 0) {
            let start = <div>En attente du juge {this.props.judgeName}...</div>;

            if (this.props.judge) {
                start = <Button variant="primary" disabled={this.disabledGo} onClick={this.start}>
                    Commencer !
                </Button>
            }

            content = <>
                <Row>
                    <Col>
                        <div className="code-header pb-4">
                            Prêts !
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {start}
                    </Col>
                </Row>
            </>
        } else {
            content = <>
                <Row>
                    <Col>
                        <div className="code-header pb-4">
                            En attente de
                        </div>
                    </Col>
                </Row>
                {
                    this.props.waitingFor.map((v, i) =>
                        <Row>
                            <Col>
                                {v}
                            </Col>
                        </Row>
                    )
                }
            </>

        }

        let admin = <div></div>

        if (this.props.admin) {
            admin = <Button variant="danger" className="mt-5" onClick={this.cancel}>
                Annuler
            </Button>
        }

        return (<div className="text-center pt-4">
            {content}
            {admin}
        </div>);
    }
}